import { RouteConfigSingleView } from 'vue-router/types/router'
import Router from 'vue-router/types'
import { VueConstructor } from 'vue/types/vue'


export enum RouteGroup {
    DEFAULT = 'DEFAULT',
    INTEGRATION = 'INTEGRATION',
    REPORTS = 'REPORTS',
    BILLING = 'BILLING',
    SOCIAL_MEDIA = 'SOCIAL_MEDIA',
    TWM = 'TWM',
    EMP_REW = 'EMP_REW',
    FRANCHISE_MGMT = 'FRANCHISE_MGMT',
    TECH_TEAM = 'TECH_TEAM'
}


export interface ExtendedRouteConfig extends RouteConfigSingleView {
    component: Function|VueConstructor;
    name: string;
    meta: {
        title: string;
        updateTitle: boolean;
        displayHome: boolean;
        displayNav: boolean;
        group: RouteGroup;
    };
}


export interface ExtendedRouter extends Router {
    options: {
        routes: ExtendedRouteConfig[];
    };
}
